import React, { useContext, useEffect, useState } from "react";
import "./Why_Choose_Us.css";
import { Context } from "../../../utils/context";
import { whyChoose } from "../../../utils/apis/AboutUs/AboutUs";

const Why_Choose_Us = () => {

  const {
    IMG_URL,
  } = useContext(Context);

  const [whyChooseUs, setWhyChoose] = useState();
  const getAllWhyChoose = async () => {
    const res = await whyChoose("banner");

    if (res?.success) {
      setWhyChoose(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllWhyChoose();
  }, []);
  return (
    <section className="why_choose_section">
      <div className="container">
        {/* Heading */}
        <div className="why_choose_heading text-center">
          <p className="why_choose_title">Why Choose Us?</p>
          <h2 className="why_choose_subtitle">
            We are dedicated to provide quality service
          </h2>
        </div>

        <div className="row feature_cards_div">
          {whyChooseUs?.slice(0, 4)?.map((item, index) => (
            <div className="col-lg-6 col-md-6 col-sm-6 mb-4" key={index}>
              <div className="feature_card">
                <h5 className="card_title">{item.name}</h5>
                <p className="card_desc">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="vehicles_wrapper text-center">
          <img
            src="/assets/images/home/why_choose_us/vehicles.png"
            alt="vehicles"
            className="vehicles_img"
          />
        </div>
      </div>
    </section>
  );
};

export default Why_Choose_Us;
